import { ProductKey } from 'root-constants'

export const SINGLE_SUBSCRIPTIONS: string[] = [
  ProductKey.UPSELL_HOW_TO,
  ProductKey.UPSELL_FINDING,
]

export const SINGLE_SUBSCRIPTION_AS_NUMBER = 1
